/** @jsx jsx */
import type { ReactNode } from 'react';
import { jsx } from '@emotion/core';

import Wrapper from './Wrapper';

type Props = {
  children: ReactNode;
  onClickTestAgain: () => void;
};

const Tab = (props: Props) => {
  const { children, onClickTestAgain } = props;

  return <Wrapper onClickTestAgain={onClickTestAgain}>{children}</Wrapper>;
};

Tab.defaultProps = {
  children: null,
};

export default Tab;
